import { useSyncExternalStore } from "react";
import { getStorePlatformFromUserAgent, type StorePlatform } from "#website-store-links";

const MACINTOSH_USER_AGENT_REGEX = /macintosh/i;

function subscribe(): () => void {
  return () => {};
}

function getClientStorePlatform(): StorePlatform | null {
  const platform = getStorePlatformFromUserAgent(navigator.userAgent);
  // iPadOS Safari reports a desktop Mac user agent; touch support tells the two apart.
  if (
    platform === null &&
    MACINTOSH_USER_AGENT_REGEX.test(navigator.userAgent) &&
    navigator.maxTouchPoints > 1
  ) {
    return "ios";
  }
  return platform;
}

function getServerStorePlatform(): StorePlatform | null {
  return null;
}

/**
 * The store that serves the visitor's device, or `null` on desktops. The server render (and the
 * hydration pass) always sees `null`, so platform-specific ordering applies right after hydration
 * without a mismatch.
 */
export function useWebsiteStorePlatform(): StorePlatform | null {
  return useSyncExternalStore(subscribe, getClientStorePlatform, getServerStorePlatform);
}
